import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import {
  ConfigModule,
  GlobalMessageService,
  GlobalMessageType,
  LanguageService,
  OccEndpointsService,
  RoutingService,
  TranslationService
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import * as _ from 'underscore';
import { CustomAddToCartService } from '../../../custom-add-to-cart/custom-add-to-cart.service';
import { ProductDetailsComponent } from '../../../custom-add-to-cart/custom-add-to-cart/product-details/product-details.component';
import { CustomInfluenzaService } from '../../../custom-influenza/custom-influenza.service';
import { ProductDetailsInfluenzaComponent } from '../../../custom-influenza/product-details-influenza/product-details-influenza.component';
import { CustomPdpService } from '../../../custom-pdp/custom-pdp.service';
import { CustomProfileAndPreferencesService } from '../../../custom-profile-and-preferences/custom-profile-and-preferences.service';
import { ssGlobalMessageConfigFactory } from '../../config/global-messages.config';
import { DataLayerService } from '../../services/data-layer.service';
import { AddCardService } from '../add-card/add-card.service';
import { CheckoutService } from '../checkout/checkout.service';
import { combineLatest, filter, first } from 'rxjs';
import { InvoiceUtils } from '../../utils/invoice.utils';
import { PaymentsMods, PreferencesTabs, SalesOrg } from '../../config/app.config';
import { PaymentInfo } from '../../models/payment-info.model';
import { tap } from 'rxjs/operators';
import { CommonUtils } from '../../utils/common.utils';
import * as moment from 'moment';

imports: [ConfigModule.withConfigFactory(ssGlobalMessageConfigFactory)];

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckoutComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly splitOrder = signal(false);
  @Input() cartDetails: any;
  @Input() stdCartType: boolean;
  @Input() accountLocData: any;
  @Input() activeSeasonId: any;

  @ViewChild('continueCheckout', { static: false })
  private readonly continueCheckout;
  paymentsArray: any = [];
  chosenPaymentMethod: string;
  chosenCard: any;
  chosenAccount: any;
  screenwidth: any;
  selectedHeader: any = 'Checkout';
  cartId: any;
  userId: any;
  standardCartDetails: any;
  productEntries: any = [];
  public images: any;
  updateEntriesData: any = [];
  subTotal: number;
  baseUrl: string;
  editNotClicked = true;
  userCardDataArray: any = [];
  userCheckingAccountsArray = [];
  userTemporaryCard: any;
  failedContactUpdate = false;
  editStdForm = new FormGroup({
    firstName: new FormControl('', [
      Validators.required,
      Validators.pattern("^[a-zA-Z0-9-' ]+('[a-zA-Z0-9-])?[-a-zA-Z0-9]*$"),
    ]),
    phone: new FormControl('', [
      Validators.required,
      Validators.pattern('^[0-9]{3}-[0-9]{3}-[0-9]{4}$'),
    ]),
    mobile: new FormControl('', [
      Validators.pattern('^[0-9]{3}-[0-9]{3}-[0-9]{4}$'),
    ]),
    emailId: new FormControl(''),
    newemailId: new FormControl('', [
      Validators.pattern('^[a-z0-9_.]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
    ]),
  });
  userCardData: any = [];
  childCarts: any = [];
  orderContact: any;
  emailsArray: any = [];
  estimatedDate: any = '';
  getuserData: any;
  userAccountgetData: any;
  selectedData: any;
  fallbackImage = '../i18n-assets/sanofishoppe_missing_product.png';
  chosenEmail: any;
  orderNo: string;
  attentionLine: string;
  billingAddress: any;
  soldToAddress: any;
  selectedPaymentMethod = signal<PaymentInfo>({} as PaymentInfo);
  selectedcardHolderName: string;
  selectedcardNumber: string;
  selectedRoutingNumber: string;
  selectedcardType: string;
  selectedexpDate: string;
  totalInfluenzaProducts: any = 0;
  totalInfluenzaDoses: number = 0;
  displayPaymentMethod: any;
  deleteEmail: boolean;
  usergetDataObj: any;
  disabled = true;
  freightProduct = false;
  @ViewChild('myPopover') myPopover: NgbPopover;
  userFname: any;
  userLname: any;
  userEmail: any;
  productsForExcel: any = [];
  checkoutSubscriber: any;
  hidePaymentMethod = true;
  cardExpiredFlag = false;
  influenzaCartIdSubscriber: any;
  influenzaCreateCartSubscriber: any;
  addCardSubscriber: any;
  userAccountSubscriber: any;
  userAccountDetailsSubscriber: any;
  stdChekoutSubscriber: any;
  cardDetailsPfSubscriber: any;
  paymentModesSubscriber: any;
  updateContactSubscriber: any;
  updatedStdOrderSubscriber: any;
  updatedPoNumberSubscriber: any;
  updatedInfluenzaOrderDetailsSubscriber: any;
  emailSubscriber: any;
  prodCodeSubscriber: any;
  faPenToSquare = faPenToSquare;
  genMedFlag = false;
  isBIVV = false;
  isPRE = false;
  dateFormat = 'MM/dd/yyyy';
  salesOrg: string;
  disablePlaceOrderBtn: boolean = false;
  multipleOrder: boolean = false;
  stdProdEntries: any = [];
  fitProdEntries: any = [];
  combinedProdEntries: any = [];
  orderMessage: string = '';
  poNumberChecked: boolean;
  formatCardData: any[] = [];
  formatEcheckAccountData: any[] = [];
  paymentModes: PaymentsMods[] = [];
  allPaymentsMethods: PaymentInfo[] = [];
  payNowDisabled = signal(false);
  protected readonly PaymentsMods = PaymentsMods;
  protected readonly SalesOrg = SalesOrg;

  constructor(
    private readonly influenzaService: CustomInfluenzaService,
    private readonly checkoutService: CheckoutService,
    private readonly user: UserAccountFacade,
    private readonly addToCartService: CustomAddToCartService,
    private readonly ref: ChangeDetectorRef,
    protected readonly modalService: NgbModal,
    private readonly pfService: CustomProfileAndPreferencesService,
    private readonly router: RoutingService,
    private readonly occEndPoint: OccEndpointsService,
    private readonly pdpService: CustomPdpService,
    private readonly addCardService: AddCardService,
    private readonly globalMessage: GlobalMessageService,
    private readonly translation: TranslationService,
    private readonly lang: LanguageService,
    private readonly dataLayerService: DataLayerService
  ) {
    this.screenwidth = window.screen.width;
  }

  ngOnInit() {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
    this.user.get()
      .pipe(
        filter(Boolean)
      )
      .subscribe((res: any) => {
        this.userId = res?.userName;
        this.userFname = res?.firstName;
        this.userLname = res?.lastName;
        this.userEmail = res?.email;
        this.influenzaService.getCartIdofUser(this.userId);
        this.influenzaCartIdSubscriber = this.influenzaService.cartIdActiveOfUser.subscribe((cartIdData) => {
          if (cartIdData) {
            if (cartIdData?.carts?.length > 0) {
              const cartIdResponse = cartIdData?.carts;

              let activeCartIdArray = [];
              activeCartIdArray = cartIdResponse?.filter((item) => item?.saveTime === undefined);
              this.cartId = activeCartIdArray[activeCartIdArray?.length - 1]?.code;
            }
          }
        });
        this.settingStdCartAccountDetals();
        this.addToCartService.getAllCarts(res?.userName);
        if (this.stdCartType) {
          this.stdCartCheckoutDetails();
        } else {
          this.influenzaCartCheckoutDetails();
        }
      });
    this.addCardSubscriber = this.addCardService.cardAdded
      .pipe(
        filter(Boolean)
      )
      .subscribe((res) => {
        if (res.defaultPayment && res.addPaymentDetails) {
          this.getCardDetailsForStdCart(this.usergetDataObj?.uid);
          return;
        }

        const expDateSplit = res.validTo.split('/')

        const tempCard = {
          businessPartner: '',
          cardExpired: '',
          cardId: '',
          cardNumber: res.cardNumber,
          cardType: res.cardType.code,
          creditCardDefault: res.defaultPayment,
          creditCardName: res.accountHolderName,
          expDate: `${ expDateSplit[1] }/${ expDateSplit[2] }`,
          maskNumber: '',
          routingNumber: res.routingNumber || '',
          status: '',
          statusMessage: '',
          validTo: res.validTo.length ? moment(res.validTo).format('DD/MM/YYYY') : '',
        }

        const formatTempCard = InvoiceUtils.formatSingleCard(tempCard);
        this.allPaymentsMethods.push(formatTempCard);
        this.selectedPaymentMethod.set(formatTempCard);
        this.addCardService.cardAdded.next(false);
      });
    this.poNumberChecked = false;
  }

  ngAfterViewInit(): void {
    if (!this.stdCartType) {
      this.myPopover.open();
    }
  }

  ngOnDestroy() {
    this.influenzaCartIdSubscriber?.unsubscribe();
    this.influenzaCreateCartSubscriber?.unsubscribe();
    this.addCardSubscriber?.unsubscribe();
    this.checkoutSubscriber?.unsubscribe();
    this.userAccountSubscriber?.unsubscribe();
    this.userAccountDetailsSubscriber?.unsubscribe();
    this.stdChekoutSubscriber?.unsubscribe();
    this.cardDetailsPfSubscriber?.unsubscribe();
    this.updateContactSubscriber?.unsubscribe();
    this.updatedStdOrderSubscriber?.unsubscribe();
    this.updatedPoNumberSubscriber?.unsubscribe();
    this.updatedInfluenzaOrderDetailsSubscriber?.unsubscribe();
    this.emailSubscriber?.unsubscribe();
    this.prodCodeSubscriber?.unsubscribe();
    this.paymentModesSubscriber?.unsubscribe();
  }

  orderNoUpdate() {
    this.dwnloadAsExcel();
  }

  dwnloadAsExcel() {
    this.productsForExcel = [];

    this.productEntries.forEach((entries, index) => {
      this.productsForExcel.push({
        Customer: this.standardCartDetails?.shipToParty?.billingAddress?.unitID,
        'Material ID': entries?.product?.code,
        Quantity: entries?.quantity,
        'PO Number': this.orderNo,
      });
      if (index + 1 === this.productEntries.length) {
        this.influenzaService.dataForExcel = this.productsForExcel;
      }
    });
  }

  influenzaCartCheckoutDetails() {
    this.influenzaService.getActiveSeasonsFromDb(this.userId);
    this.influenzaService.activeSeaons
      .pipe(
        first(Boolean)
      )
      .subscribe((data) => {
          this.activeSeasonId = data?.categoryData?.[0]?.code;
        }
      );
    this.influenzaService.checkoutInfluenza$
      .pipe(
        first(Boolean)
      )
      .subscribe((res: any) => {
        let stdCartDetails: any[] = res?.childCarts;
        if (stdCartDetails) {
          stdCartDetails = stdCartDetails.filter((item) => item.cartType === 'INFLUENZA');
          this.standardCartDetails = Object.assign({}, ...stdCartDetails);
          this.orderContact = this.standardCartDetails.orderContact;
          for (const cartDetails of stdCartDetails) {
            for (let entries of cartDetails.entries) {
              if (entries?.product?.onsn === 'ON') {
                this.estimatedDate = entries?.estimatedDeliveryDate;
              }
              if (entries?.freightProduct) {
                this.freightProduct = entries?.freightProduct;
              }
              const imagesFormat = _.clone(
                _.findWhere(entries.product?.images, { format: 'thumbnail' })
              );
              if (imagesFormat) {
                imagesFormat.url = `${ this.baseUrl }${ imagesFormat?.url }`;
              }
              this.images = { PRIMARY: imagesFormat };
              entries = { ...entries, ...this.images };
              this.totalInfluenzaProducts = 0;
              this.totalInfluenzaDoses = 0;
              this.productEntries.push(entries);
            }
          }
          let onsnCounter = 0;
          this.productEntries?.forEach((element, index) => {
            if (element?.product?.onsn === 'ON') {
              onsnCounter += 1;
            }
            this.totalInfluenzaProducts += parseInt(element.quantity);
            const a = parseInt(element.quantity);
            const b = parseInt(element.product.quantityPerUnit);
            this.totalInfluenzaDoses = this.totalInfluenzaDoses + a * b;

            if (index + 1 === this.productEntries.length) {
              if (onsnCounter === 0) {
                this.hidePaymentMethod = true;
                this.ref.detectChanges();
              }
              if (this.standardCartDetails?.shipToParty) {
                this.selectedData =
                  this.standardCartDetails?.shipToParty?.shippingAddresses?.filter(
                    (item) =>
                      item.unitID === this.standardCartDetails.shipToParty.uid
                  );
                if (!!this.selectedData?.length) {
                  this.selectedData = _.first(this.selectedData);
                } else {
                  this.selectedData = _.first(
                    this.standardCartDetails?.shipToParty?.shippingAddresses
                  );
                }
              } else {
                if (this.getuserData && this.getuserData?.length > 0) {
                  this.selectedData = _.first(
                    this.getuserData.filter(
                      (item) => item.unitID === this.userAccountgetData?.uid
                    )
                  );
                }
              }
              this.dwnloadAsExcel();
            }

            this.ref.detectChanges();
          });
          this.ref.detectChanges();
        }
      });
  }

  settingStdCartAccountDetals() {
    this.checkoutService.getUserAccountDataFromDb(this.userId);
    this.userAccountSubscriber = this.checkoutService.userAccountData
      .pipe(
        filter((userData: any) => userData?.res?.defaultB2BUnit)
      )
      .subscribe((userData) => {
        this.usergetDataObj = userData.res.defaultB2BUnit;
        const accountId = this.usergetDataObj?.uid;
        this.getCardDetailsForStdCart(accountId);
        this.checkoutService.getUserAccountDetailsDataFromDb(this.userId, accountId);
        this.genMedFlag = userData?.res?.defaultB2BUnit?.salesOrg === SalesOrg.US03;
        this.isPRE = userData?.res.defaultB2BUnit?.paymentTerms.indexOf('PRE') > -1;
        this.isBIVV = userData?.res.defaultB2BUnit?.salesOrg.indexOf(SalesOrg.US12) > -1;

        this.salesOrg = userData?.res?.defaultB2BUnit?.salesOrg;
      });
    this.userAccountDetailsSubscriber = this.checkoutService.userAccountDetails$
      .pipe(
        filter(Boolean)
      )
      .subscribe((userDataget) => {
        this.getuserData = userDataget.res.shippingAddresses;
      });
    this.ref.detectChanges();
  }

  stdCartCheckoutDetails() {
    this.stdChekoutSubscriber = this.addToCartService.checkoutDetails$.subscribe((res: any) => {
      if (!res) {
        this.router.goByUrl('cart');

        return;
      }

      let stdCartDetails = [];
      this.productEntries = [];
      stdCartDetails = res?.childCarts;
      this.orderMessage = res?.message;
      if (stdCartDetails) {
        stdCartDetails = stdCartDetails.filter((item) => item.cartType === 'STANDARD');
        this.dataLayerService.beginCheckoutDataLayer(stdCartDetails);
        this.standardCartDetails = Object.assign({}, ...stdCartDetails);
        this.splitOrder.set(!!this.standardCartDetails?.forcedBillMeLater);
        this.orderContact = this.standardCartDetails.orderContact;

        for (const cartDetails of stdCartDetails) {
          for (let entries of cartDetails.entries) {
            this.estimatedDate = entries?.estimatedDeliveryDate;
            if (entries?.freightProduct) {
              this.freightProduct = entries?.freightProduct;
            }
            this.productEntries.push(entries);
          }
        }
        if (this.standardCartDetails?.shipToParty) {
          this.selectedData =
            this.standardCartDetails?.shipToParty?.shippingAddresses?.filter(
              (item) =>
                item.unitID === this.standardCartDetails.shipToParty.uid
            );
          if (!!this.selectedData?.length) {
            this.selectedData = _.first(this.selectedData);
          } else {
            this.selectedData = _.first(
              this.standardCartDetails?.shipToParty?.shippingAddresses
            );
          }
        } else {
          if (this.getuserData && this.getuserData?.length > 0) {
            this.selectedData = _.first(
              this.getuserData.filter(
                (item) => item.unitID === this.userAccountgetData?.uid
              )
            );
          }
        }
        const std = stdCartDetails[0].entries;
        this.fitProdEntries = _.filter(std, function (val) {
              return val.product.fitusiran || val.product.wayrilz;;
        });

        this.stdProdEntries = _.filter(std, function (val) {
              return !val.product.fitusiran && !val.product.wayrilz;;
        });
        this.combinedProdEntries = [
          ...this.fitProdEntries,
          { multi: true },
          ...this.stdProdEntries,
        ];
        if (this.combinedProdEntries) {
          for (const entry of this.combinedProdEntries) {
            const imagesFormat = _.clone(
              _.findWhere(entry.product?.images, { format: 'thumbnail' })
            );
            if (imagesFormat) {
              imagesFormat.url = `${ this.baseUrl }${ imagesFormat?.url }`;
              entry.PRIMARY = imagesFormat;
            }
          }
        }

        this.multipleOrder = this.fitProdEntries.length >= 1 && this.stdProdEntries.length >= 1;
        this.ref.detectChanges();
      }
    });
  }

  getCardDetailsForStdCart(accountId) {
    this.pfService.getCardFromDb(accountId);
    combineLatest([
      this.pfService.cardDetails,
      this.checkoutService.getPaymentModesMapped(this.userId)
    ])
      .pipe(
        first(Boolean)
      )
      .subscribe(([data, paymentModes]) => {
        this.paymentModes = paymentModes;
        this.allPaymentsMethods = InvoiceUtils.formatCardData(data.sanofiPaymentsResponseList)
          .filter(paymentType => this.paymentModes.includes(paymentType.PaymentMethod));

        this.formatCardData = this.allPaymentsMethods.filter(card => card.cardType !== 'EC');
        this.formatEcheckAccountData = this.allPaymentsMethods.filter(card => card.cardType === "EC");


        const defaultCard = this.allPaymentsMethods?.find((item) => item.creditCardDefault === true);

        if (!data?.payNowEnabledForSite) {
          this.payNowDisabled.set(!data?.payNowEnabledForSite);
          return;
        }

        if (defaultCard && !this.splitOrder() && this.isPRE) {
          this.selectedPaymentMethod.set(defaultCard);
        } else {
          this.selectedPaymentMethod.set(CommonUtils.setBillMeLaterMethod());
        }

        if (defaultCard?.cardExpired) {
          this.globalMessage.add({ key: 'addToCartItems.cardExpMsg' }, GlobalMessageType.MSG_TYPE_ERROR);
        }

        this.ref.detectChanges();
      });
  }

  updateOrderContact(): void {
    this.failedContactUpdate = false;
    const params = {
      email: this.editStdForm.controls.emailId.value,
      mobileNo: this.editStdForm.controls.mobile.value ? this.editStdForm.controls.mobile.value : '',
      name: this.editStdForm.controls.firstName.value,
      phoneNo: this.editStdForm.controls.phone.value ? this.editStdForm.controls.phone.value : '',
      standardCart: true,
    };
    //console.log(this.editStdForm)
    if (this.chosenEmail === 'Add Other E-mail Address') {
      params['addEmail'] = this.editStdForm.controls.newemailId.value;
      params.email = '';
      this.editStdForm.controls['newemailId'].setValidators([
        Validators.required,
        Validators.pattern('^[a-z0-9_.]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
      ]);
      this.editStdForm.controls['newemailId'].updateValueAndValidity();
      this.editStdForm.controls['emailId'].clearValidators();
      this.editStdForm.controls['emailId'].updateValueAndValidity();
    } else {
      this.editStdForm.controls['emailId'].setValidators(Validators.required);
      this.editStdForm.controls['emailId'].updateValueAndValidity();
      this.editStdForm.controls['newemailId'].clearValidators();
      this.editStdForm.controls['newemailId'].updateValueAndValidity();
    }
    if (this.editStdForm.valid) {
      this.checkoutService.updateContact(params, this.userId, this.cartId);
      this.updateContactSubscriber =
        this.checkoutService.updatedContact.subscribe((res) => {
          if (res) {
            this.orderContact = res;
            this.ref.detectChanges();
          }
        });
      this.editNotClicked = true;
    } else {
      this.failedContactUpdate = true;
    }
  }

  checkout(): void {
    if ((this.orderNo == undefined || this.orderNo == '') && !this.genMedFlag) {
      this.globalMessage.add('Add PO number', GlobalMessageType.MSG_TYPE_ERROR);
    }
    if (this.cardExpiredFlag) {
      this.globalMessage.add({ key: 'addToCartItems.cardExpMsg' }, GlobalMessageType.MSG_TYPE_ERROR);
    } else {
      if (
        this.selectedcardNumber ||
        this.displayPaymentMethod === 'Bill Me Later' ||
        this.displayPaymentMethod === 'Facturez-moi plus tard'
      ) {
        this.modalService.open(this.continueCheckout);
      } else {
        this.globalMessage.add({ key: 'addToCartItems.invalidPayment' }, GlobalMessageType.MSG_TYPE_ERROR);
      }
    }
  }

  checkPOnumber(): void {
    if (this.poNumberChecked) {
      this.modalService.open(this.continueCheckout);
    }
    this.disablePlaceOrderBtn = false;
    if ((this.orderNo == undefined || this.orderNo == '') && !this.genMedFlag) {
      this.globalMessage.add('Add PO number', GlobalMessageType.MSG_TYPE_ERROR);
    }
    const params = {};
    this.checkoutService.checkPOnumber(this.userId, this.orderNo, params);
    //console.log(this.checkoutService.userAccountDetails.getValue());
    this.updatedPoNumberSubscriber = this.checkoutService.updatedPOnumberDetails.subscribe((res) => {
      if (res) {
          this.globalMessage.add(
            'This PO number has already been used. You may update it or proceed ',
            GlobalMessageType.MSG_TYPE_ERROR
          );
        this.poNumberChecked = true;
      } else {
        this.modalService.open(this.continueCheckout);
      }
    });
  }

  placeOrder() {
    this.disablePlaceOrderBtn = true;
    this.modalService.open(this.continueCheckout);

    let params: any = {
      cardHolderName: this.selectedPaymentMethod().creditCardName,
      cardNumber: this.selectedPaymentMethod().cardNumber,
      cardType: this.selectedPaymentMethod().cardType,
      expDate: this.selectedPaymentMethod().expDate,
      paymentMethod: this.selectedPaymentMethod().PaymentMethod,
      purchaseOrderNumber: this.orderNo ? this.orderNo : '',
      addressAttentionLine: this.attentionLine ? this.attentionLine : '',
      seasonId: !this.stdCartType ? this.activeSeasonId : '',
      standardCart: this.stdCartType,
    };

    if (this.selectedPaymentMethod().PaymentMethod === PaymentsMods.ECHECK) {
      params = {
        ...params,
        routingNumber: this.selectedPaymentMethod().routingNumber,
      };
    }
    this.checkoutService.updateOrder(this.userId, this.cartId, params);
    this.checkoutService.updatedStdOrderDetails$
      .pipe(
        tap(() => {
          this.disablePlaceOrderBtn = true;
        }),
        first(Boolean)
      )
      .subscribe((res) => {
        if (res && res?.status == 400) {
          this.modalService.dismissAll();
        } else if (res && this.stdCartType) {
          this.router.goByUrl('/place-order-confirmation');
          this.modalService.dismissAll();
          this.disablePlaceOrderBtn = false;
        }
      });

    this.updatedInfluenzaOrderDetailsSubscriber =
      this.checkoutService.updatedOrderDetails.subscribe((res) => {
        if (!this.stdCartType && res) {
          this.addToCartService.getAllCarts(this.userId);
          this.influenzaService.checkoutInfluenza?.next(false);
          this.router.goByUrl('/influenza/orderConfirmation');
          this.modalService.dismissAll();
          this.disablePlaceOrderBtn = false;
        }
      });
  }

  emailsList(): void {
    this.checkoutService.getEmails(this.userId, this.usergetDataObj?.uid);
    this.emailSubscriber = this.checkoutService.emails$.subscribe(
      (emailsList) => {
        if (emailsList) {
          this.emailsArray = [];
          this.emailsArray = emailsList;
          if (!this.emailsArray?.includes('Add Other E-mail Address')) {
            this.emailsArray.push('Add Other E-mail Address');
          }
          this.checkoutService.emails.next(false);
        }
      }
    );
  }

  editContact() {
    this.editNotClicked = false;
    this.emailsList();
    this.editStdForm.patchValue({
      firstName: this.orderContact?.name,
      emailId: this.orderContact?.email,
      phone: this.orderContact?.phoneNo ? this.orderContact.phoneNo : '',
      mobile: this.orderContact?.mobileNo ? this.orderContact.mobileNo : '',
    });
    this.chosenEmail = this.orderContact?.email ? this.orderContact.email : '';
  }

  onCancelClick() {
    this.editNotClicked = true;
  }

  handleCardExpiration() {
    if (this.cardExpiredFlag) {
      this.translation
        .translate('addToCartItems.cardExpMsg')
        .subscribe((res) => {
          this.globalMessage.add(res, GlobalMessageType.MSG_TYPE_ERROR);
        });
    }
  }

  getCardDetailsOfUser(event) {
    this.selectedcardHolderName = event.cardHolderName;
    this.selectedcardNumber = event.cardNumber;
    this.selectedcardType = event.cardType;
    this.selectedexpDate = event.expDate;
    this.cardExpiredFlag = event.cardExpired;
    this.selectedRoutingNumber = event.routingNumber;
    if (this.cardExpiredFlag) {
      this.translation
        .translate('addToCartItems.cardExpMsg')
        .subscribe((res) => {
          this.globalMessage.add(res, GlobalMessageType.MSG_TYPE_ERROR);
        });
    }
  }

  openModal(): void {
    this.addCardService.addCardWithMFA(false, false, !this.selectedPaymentMethod());
  }

  openAch(): void {
    this.addCardService.addCardWithMFA(true, false, !this.selectedPaymentMethod());
  }

  toggle(popover: NgbPopover): void {
    popover.toggle();
  }

  navigateToCart(): void {
    if (this.stdCartType) {
      this.router.goByUrl('/cart');
    } else {
      this.router.goByUrl('/influenza/cart');
    }
  }

  productDetails(productDetails): void {
    if (this.stdCartType) {
      const modalRef = this.modalService.open(ProductDetailsComponent, {
        windowClass: 'product-details-modal',
      });
      modalRef.componentInstance.productDetails = productDetails;
      modalRef.componentInstance.standardCartCode =
        this.standardCartDetails.code;
      modalRef.componentInstance.unitSection = 'NoUnits';
    } else {
      this.pdpService.getPDPCategory(productDetails.product.code);
      this.prodCodeSubscriber = this.pdpService.productCode$.subscribe(
        (res) => {
          if (res && res?.code === productDetails.product.code) {
            this.modalService.dismissAll();
            const modalRef = this.modalService.open(
              ProductDetailsInfluenzaComponent,
              { windowClass: 'product-details-inf-modal' }
            );
            modalRef.componentInstance.productDetails = res;
            modalRef.componentInstance.standardCartCode = res.code;
          }
        }
      );
    }
  }

  billingAccount(): void {
    void this.router.go(['/my-account/profile'], {
      queryParams: { activeTab: PreferencesTabs.ACCOUNT },
    });
  }

  editOrder(): void {
    this.modalService.dismissAll();
  }

  delEmail() {
    this.editStdForm.controls['newemailId'].setValue('');
    this.chosenEmail = this.orderContact.email;
  }
}
